/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_cloud } from './file/cloud.icon';
import { icon_attachment } from './file/attachment.icon';
import { icon_cloud_circle } from './file/cloud_circle.icon';
import { icon_cloud_done } from './file/cloud_done.icon';
import { icon_cloud_download } from './file/cloud_download.icon';
import { icon_cloud_off } from './file/cloud_off.icon';
import { icon_cloud_queue } from './file/cloud_queue.icon';
import { icon_cloud_upload } from './file/cloud_upload.icon';
import { icon_file_download } from './file/file_download.icon';
import { icon_create_new_folder } from './file/create_new_folder.icon';
import { icon_file_upload } from './file/file_upload.icon';
import { icon_folder } from './file/folder.icon';
import { icon_folder_shared } from './file/folder_shared.icon';
import { icon_folder_open } from './file/folder_open.icon';
var icons = {
  "cloud" : icon_cloud,
"attachment" : icon_attachment,
"cloud_circle" : icon_cloud_circle,
"cloud_done" : icon_cloud_done,
"cloud_download" : icon_cloud_download,
"cloud_off" : icon_cloud_off,
"cloud_queue" : icon_cloud_queue,
"cloud_upload" : icon_cloud_upload,
"file_download" : icon_file_download,
"create_new_folder" : icon_create_new_folder,
"file_upload" : icon_file_upload,
"folder" : icon_folder,
"folder_shared" : icon_folder_shared,
"folder_open" : icon_folder_open,
};
export { icons };
